usersModule.factory("User",
    ['imSessionVarsService',
    function(imSessionVarsService) {

        var User = function () {
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.loginId = '';
            this.isActive = true;
            this.roles = [];
            this.id = '';
            this.selected = false;
            this.divisions = [];
            this.regions = [];
            this.districts = [];
            this.groups = [];
            this.dealerships = [];

            // What is backingData and why do we need it?
            // basically, the backing data is the data as we get it from the database - the current database implementation
            // does not update intelligently, it just overwrites everything in there with whatever you pass in, so
            // you have to make sure to pass it back all the same data it gave you, except for the values that
            // changed.
            this.backingData = null;
        };

        User.prototype.convertForIdentityManagement = function() {
            var userData;
            if(this.backingData) {
                // if we have backingData, that means we retrieved this object from the database. The backingData is already
                // in the correct format for sending it back to the db, so we don't need to create a new object - just
                // update the backingData itself
                this.backingData.FirstName = this.firstName;
                this.backingData.LastName = this.lastName;
                this.backingData.Email = this.email;
                this.backingData.UserName = this.loginId;
                this.backingData.IsActive = this.isActive;
                this.backingData.Claims = this.roles;
                userData = this.backingData;
            } else {
                userData = {
                    FirstName: this.firstName,
                    LastName: this.lastName,
                    Email: this.email,
                    UserName: this.loginId,
                    IsActive: this.isActive,
                    Claims: this.roles
                };
            }

            if(!userData.PrimaryProviderId)
                userData.PrimaryProviderId = imSessionVarsService.getCurrentProviderId();

            return userData;
        };

        User.prototype.populateDataFromIdentityManagement = function(data) {
            this.id = data.Id;
            this.firstName = data.FirstName;
            this.lastName = data.LastName;
            this.email = data.Email;
            this.loginId = data.UserName;
            this.isActive = data.IsActive;
            this.selected = false;
            this.backingData = data;
            this.roles = data.Claims;
        };

        return User;
    }
]);